var render, staticRenderFns
import script from "./chart-doughnut.vue?vue&type=script&lang=js"
export * from "./chart-doughnut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c3d14c",
  null
  
)

/* custom blocks */
import block0 from "./chart-doughnut.vue?vue&type=custom&index=0&blockType=div"
if (typeof block0 === 'function') block0(component)

export default component.exports